import { OrganizerAction, OrganizerActionType } from '../actions/organizer';
import { OrganizerNamespace } from '../state/organizer';

export const organizerReducer = (
    state: OrganizerNamespace = {
        enableOrganizerMarketingOptIn: false,
        logoUrl: null,
        name: null,
    },
    action: OrganizerAction,
) => {
    switch (action.type) {
        case OrganizerActionType.setOrganizerMarketingOptIn:
            return {
                ...state,
                enableOrganizerMarketingOptIn: action.payload,
            };

        case OrganizerActionType.setOrganizerNameAndLogo:
            return {
                ...state,
                logoUrl: action.payload.logoUrl,
                name: action.payload.name,
            };

        default:
            return state;
    }
};
